@if (showWarning) {
  <div class="overlay">
    <mat-card class="warning-card" appearance="raised">
      <mat-card-header>
        <mat-card-title class="card-title mat-card-title-sm">
          <mat-icon color="warn" class="mat-icon-lg not-shrink">warning</mat-icon>
          Your browser version is outdated
        </mat-card-title>
      </mat-card-header>
      <mat-card-content class="card-content">
        <div class="content">
          <span>
            You're using <strong>{{ browserInfo?.name }} {{ browserInfo?.version }}</strong>. This application may be unstable or have limited functionality.
          </span>
          <span>
            For the best experience, please update to:
            <strong>{{ recommendedBrowsers }}</strong>
          </span>
        </div>
        <button mat-button (click)="dismiss()" class="not-shrink">Dismiss</button>
      </mat-card-content>
    </mat-card>
  </div>
}
